import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import {
  useNavigate,
} from 'react-router-dom';

import {
  useTranslation,
} from 'react-i18next';

import SignupMergedForm
  from './components/SignupMergedForm';

import AppHeader
  from '../../../shared/layouts/AppHeader';

import {
  createMasterAccount,
} from '../services/signupService';

import './SignUpPage.css';


export default function SignUpPage() {
  const navigate =
    useNavigate();

  const { t } =
    useTranslation('app');

  const [
    submitError,
    setSubmitError,
  ] =
    useState('');

  const [
    submitSuccess,
    setSubmitSuccess,
  ] =
    useState('');

  const [
    isSubmitting,
    setIsSubmitting,
  ] =
    useState(false);

  const successDialogRef = useRef(null);

  useEffect(() => {
    if (!submitSuccess) {
      return;
    }

    const dialog = successDialogRef.current;
    dialog.showModal();

    const timeoutId = window.setTimeout(() => {
      dialog.close();
      navigate('/', { replace: true });
    }, 1200);

    return () => {
      window.clearTimeout(timeoutId);
      dialog.close();
    };
  }, [submitSuccess, navigate]);


  const handleBackToLogin =
    () => {
      navigate(
        '/',
        {
          replace:
            true,
        },
      );
    };


  const handleCreateAccount =
    async (
      signupData,
    ) => {
      if (
        isSubmitting || submitSuccess
      ) {
        return;
      }

      setSubmitError(
        '',
      );

      setSubmitSuccess(
        '',
      );

      setIsSubmitting(
        true,
      );

      try {
        const response =
          await createMasterAccount(
            signupData,
          );

        if (
          !response?.success
        ) {
          throw new Error(
            response?.message ||
            t(
              'signup.errors.createFailed'
            ),
          );
        }

        setSubmitSuccess(
          t(
            'signup.success.requestCompleted'
          ),
        );

      } catch (
        error
      ) {
        console.error(
          '[SignUpPage] create account failed:',
          error,
        );

        setSubmitError(
          error?.message ||
          t(
            'signup.errors.createFailed'
          ),
        );
      } finally {
        setIsSubmitting(
          false,
        );
      }
    };


  return (
    <div className="signup-page">
      <AppHeader
        pageTitle={t('signup.title')}
        pageDescription={t('signup.description')}
        onBrandClick={handleBackToLogin}
      />

      <main className="signup-panel">
        {submitError && (
          <div
            className="signup-message signup-message-error"
            role="alert"
          >
            {
              submitError
            }
          </div>
        )}


        <SignupMergedForm
          onSubmit={
            handleCreateAccount
          }
          isSubmitting={
            isSubmitting || Boolean(submitSuccess)
          }
        />


        <div className="signup-login-link-area">
          <span>
            {t(
              'signup.alreadyMember'
            )}
          </span>

          <button
            type="button"
            className="signup-text-button"
            onClick={
              handleBackToLogin
            }
          >
            {t(
              'signup.backToLogin'
            )}
          </button>
        </div>
      </main>

      <dialog
        ref={successDialogRef}
        className="signup-success-dialog"
        aria-labelledby="signup-success-message"
        onCancel={(event) => event.preventDefault()}
      >
        <div className="signup-success-icon" aria-hidden="true">✓</div>
        <p id="signup-success-message" role="status">{submitSuccess}</p>
      </dialog>
    </div>
  );
}
